import { getTimeZoneOffset } from 'owa-datetime-store';
import { now } from 'owa-datetime';
import SchedulingConstants from '../utils/SchedulingConstants';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';

/**
 * Calculates the neccessary width (in px) of the timestrip headers based on the provided time zones
 *
 * @param timeZoneIds Time zones used to calculate width
 */
export default function getTimeStripWidth(timeZoneIds: string[]): number {
    let timeStripWidth = SchedulingConstants.defaultTimeStripWidth;

    if (timeZoneIds && timeZoneIds.length > 1) {
        for (let i = 0; i < timeZoneIds.length; i++) {
            const offset = getTimeZoneOffset(now(), timeZoneIds[i]);

            if (offset % TimeConstants.MinutesInOneHour != 0) {
                timeStripWidth = SchedulingConstants.timeStripTimeZoneOverflowWidth;
                break;
            }
        }
    }

    return timeStripWidth;
}
